import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [catsOpen, setCatsOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2">
            {isHome ? (
              <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 tracking-tight">
                CSSBuy<span className="text-primary-500">Sheet</span>
              </h1>
            ) : (
              <span className="font-heading text-xl md:text-2xl font-bold text-foreground-900 tracking-tight">
                CSSBuy<span className="text-primary-500">Sheet</span>
              </span>
            )}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a href="#categories" className="text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Categories</a>
            <a href="#about" className="text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">About</a>
            <a href="#how-it-works" className="text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">How It Works</a>
            <a href="#faq" className="text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">FAQ</a>
            <Link to="/article/cssbuy-spreadsheet-guide" className="text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Guides</Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-6 py-4 flex flex-col gap-1">
            <a href="#categories" className="text-sm font-medium text-foreground-700 py-2.5 cursor-pointer" onClick={() => setMenuOpen(false)}>Categories</a>
            <a href="#about" className="text-sm font-medium text-foreground-700 py-2.5 cursor-pointer" onClick={() => setMenuOpen(false)}>About</a>
            <a href="#how-it-works" className="text-sm font-medium text-foreground-700 py-2.5 cursor-pointer" onClick={() => setMenuOpen(false)}>How It Works</a>
            <a href="#faq" className="text-sm font-medium text-foreground-700 py-2.5 cursor-pointer" onClick={() => setMenuOpen(false)}>FAQ</a>
            <Link to="/article/cssbuy-spreadsheet-guide" className="text-sm font-medium text-foreground-700 py-2.5 cursor-pointer" onClick={() => setMenuOpen(false)}>Guides</Link>

            <button
              className="flex items-center justify-between w-full py-2.5 text-sm font-medium text-foreground-700 cursor-pointer"
              onClick={() => setCatsOpen(!catsOpen)}
            >
              <span>All Categories</span>
              <i className={`text-sm transition-transform duration-200 ${catsOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
            </button>

            {catsOpen && (
              <div className="pl-3 border-l-2 border-background-200/70 ml-1 flex flex-col gap-0.5">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2.5 py-2 px-2 text-sm text-foreground-600 hover:text-foreground-900 transition-colors rounded-md hover:bg-background-100 cursor-pointer"
                    onClick={() => setMenuOpen(false)}
                  >
                    <span className="w-6 h-6 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs text-primary-500`}></i>
                    </span>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <div className="pt-3 mt-1 border-t border-background-200/70">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 w-full px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}